import React, { createContext,useState, useEffect} from 'react';
import { useSelector } from 'react-redux';
import { Field } from '../Field/Field.lite';

import { useBlockVisibility } from 'store/modules/blocks';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import { Card, CardHeader, CardContent, Box } from '@mui/material';
import { grey } from '@mui/material/colors';
import { onBlock, removeListener, requestBlock   } from 'api/prokey/prokey.websocket';
import { prokeyApi } from 'api/prokey/prokey.api';

const FieldMemo = React.memo(Field);
function Block({ id, timestamp }) {
  
  //#region [Main] State

  const theme = useTheme();

  const [block, setBlock] = useState({});
  const isVisible = block.is_visible;//useBlockVisibility(id);

  const is_loaded = !!block.Fields;

  const _styles = {
    block_container: {
      display      : isVisible ? '' : 'none',
      borderRadius : '1rem',
      width        : '100%',
      backgroundColor: theme.palette.background.primary[theme.palette.mode],
      marginBottom: '1rem',
      padding: 0,
    },
    block_container_hidden: {
      display: 'none',
    },
    block_header: {
      padding: '0.5rem',
      color: 'var(--color-primary)',
      borderRadius: '5px',
      fontSize: '120%',
      fontWeight: 'bold',
    },
    block_content_simple: {
      padding    : '0.5rem',
      border     : 0,
      boxShadow  : 0,
      display    : 'inline flex' ,
      flexFlow   : 'row no-wrap' ,
      flexWrap   : 'wrap',
      alignItems : 'flex-start'  ,
      width      : '100%'
    },
    block_content_table: {
      padding    : '0.5rem',
      display    : 'block' ,
      overflowX: 'auto'
    },
    block_grid_wrapper: {
      display: 'grid',
      position: 'static',
      overflowX: 'auto',
      overflowY: 'hidden',
      width: 'max-content',
    },
  };

  //#endregion

  //#region [EFFECT]

  useEffect( () => {
    //-----------------------------------------------------------------
    function handleBlock(data) {
      //-----------------------------------------------------------------
      setBlock(data)
    }

    onBlock( id, handleBlock );

    requestBlock( id );

    return () => {
      removeListener( 'BLOCK-'+id, handleBlock )
    }
  }, [timestamp] );

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    let result = is_loaded ? (
      <Box sx={_styles.block_container} key={id} variant='' >
        {displayHeader()}
        {block.isTable ? displayTable() : displayFields()}
      </Box>
    ) : displayDefault();
    return result;
  }

  function displayDefault() {
    return (
      <Box sx={_styles.block_container} key={id} >
        <CardHeader sx={_styles.block_header} title='Loading...' />
      </Box>
    )
  }

  //-----------------------------------------------------------------
  function displayTable() {
    //-----------------------------------------------------------------
    // sets number of rows dynamically
    const gridTemplateRows = `repeat(1}, 1fr)`;
    // const gridTemplateColumns = `repeat(${block.columns.length}, 1fr)`;
    const gridTemplateColumns = block.columns?.map((col) => {
        let val = `fit-content(${col.length * 11}px)`;
        return val;
      })
      .join(' ');

    const headers = block.columns?.map((col, index) => {

      const TABLE_HEADER = {
        sx    : { paddingBottom: 0 },
        key   : index,
        title : col.header,
      }
    
      return <CardHeader { ...TABLE_HEADER } />;
    })

    return (
      <Box sx={_styles.block_content_table} >
        <Box sx={_styles.block_grid_wrapper} style={{ gridTemplateRows, gridTemplateColumns }} >
          {headers}
          {displayTableRows()}
        </Box>
      </Box>
    );
  }

  //-----------------------------------------------------------------
  function displayTableRows() {
    //-----------------------------------------------------------------
    const block_fields = block.Fields?.map( id => <FieldMemo key={id} id={id} /> );
  
    return block_fields;
  }

  //-----------------------------------------------------------------
  function displayFields() {
    //-----------------------------------------------------------------
    const block_fields = block.Fields?.map( id => <FieldMemo key={id} id={id} timestamp={timestamp}/> );

    return (
      <Box sx={_styles.block_content_simple} >
        {block_fields}
      </Box>
    );
  }

  //-----------------------------------------------------------------
  function displayHeader() {
    //-----------------------------------------------------------------
    // Only display the header if there is more than 1 field
    return (
      block.Header !== '' && (
        <CardHeader sx={_styles.block_header} title={block.Header} />
      )
    );
  }

  //#endregion

  return display();
}

export { Block };
